"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _subjektFormatter = require("./../utils/subjektFormatter");

var subjektFormatter = _interopRequireWildcard(_subjektFormatter);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Render subjektu.
 */
// -
var SubjektRowDetail = function (_React$Component) {
    (0, _inherits3.default)(SubjektRowDetail, _React$Component);

    function SubjektRowDetail() {
        (0, _classCallCheck3.default)(this, SubjektRowDetail);
        return (0, _possibleConstructorReturn3.default)(this, (SubjektRowDetail.__proto__ || (0, _getPrototypeOf2.default)(SubjektRowDetail)).apply(this, arguments));
    }

    (0, _createClass3.default)(SubjektRowDetail, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                subjekt = _props.subjekt,
                bezAdresy = _props.bezAdresy;


            return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                    "div",
                    { className: "subjekt-name" },
                    subjektFormatter.getUplnyNazev(subjekt)
                ),
                !bezAdresy && subjekt.adresaTrv && _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "small",
                        null,
                        subjekt.adresaTrv.popis
                    )
                )
            );
        }
    }]);
    return SubjektRowDetail;
}(_react2.default.Component);

SubjektRowDetail.propTypes = {
    subjekt: _react2.default.PropTypes.object.isRequired, // subjekt
    bezAdresy: _react2.default.PropTypes.bool // u subjektu se nezobrazí řádek s adresou
};
SubjektRowDetail.defaultProps = {
    bezAdresy: false
};
exports.default = SubjektRowDetail;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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